import StringUtils from './StringUtils';
import GlobalVariables from '../GlobalVariables';
import logIt from '../../../logIt';

/**
 * a validator for detecting an agent message containing company CallConnect/Office hours of the format:
 * <optionally, any prefix phrase> Sunday: Closed, Monday: 9:00 AM-06:00 PM, Tuesday: 9:00 AM-06:00 PM, Wednesday: 9:00 AM-06:00 PM, Thursday: 9:00 AM-06:00 PM, Friday: 9:00 AM-05:00 PM, Saturday: Closed
 * @param {any} msgText
 */
const isMessageCompanyHours = (msgText) => {
    /**
     * Test message:
     'we are open Monday: 9:00 AM-06:00 PM, Tuesday: 9:00 AM-06:00 PM, Wednesday: 9:00 AM-06:00 PM, Thursday: 9:00 AM-06:00 PM, Friday: 9:00 AM-05:00 PM, Saturday: Closed, Sunday: Closed'.match(/^((\w*?)\s+)*|(Mon|Tues|Wed(nes)?|Thur(s)?|Fri|Sat(ur)?|Sun)(day)?:\s+(((1[0-2]|0?[1-9]):([0-5][0-9])\s?([AaPp][Mm])\s?-\s?(1[0-2]|0?[1-9]):([0-5][0-9])\s?([AaPp][Mm]))|Closed\,*\s*)|$/g);
     
     * */
    const regexOfficeHoursWithPrefix =
        /^(.*?\s*)|((Mon|Tues|Wed(nes)?|Thur(s)?|Fri|Sat(ur)?|Sun)(day)?:\s+((((1[0-2]|0?[1-9]):([0-5][0-9])\s?([AaPp][Mm])\s?-\s?(1[0-2]|0?[1-9]):([0-5][0-9])\s?([AaPp][Mm]))|Closed*),*\s*))|$/g;
    const result = { result: false, prefix: '', officeHrs: [] };
    let officeHours_matches = ` ${msgText}`.match(regexOfficeHoursWithPrefix); // https://regexr.com/5d0h4, https://regexr.com/5dv5f
    try {
        if (officeHours_matches && officeHours_matches.length > 0) {
            officeHours_matches = officeHours_matches.filter(
                (item) => !StringUtils.isNullOrWhiteSpace(item)
            );
            // match 1st token; if matched, extract prefix phrase if any
            const matched =
                officeHours_matches[0] &&
                officeHours_matches[0].match(GlobalVariables.regexOfficeHours);
            if (matched) {
                result.prefix = msgText.substring(0, msgText.indexOf(officeHours_matches[0])); // prefix phrase
                result.officeHrs = officeHours_matches; // all matches are office hours
            }
            result.result = officeHours_matches.length > 6; // we assume there should be at least 7 office hours
        }
    } catch (er) {
        logIt(`OH::Error extracting office hours:${er.message}`);
    }
    return result;
};
export default isMessageCompanyHours;
